import * as React from "react";
import * as ReactGA from 'react-ga';
import "./createAlert.css";
import { Row, Col } from "reactstrap";
import { IOnSelectChange } from "./components/SearchBar";
import * as _ from "lodash";
import { Form } from "../../../share/components/Form/Form";
import { toastr } from "react-redux-toastr";
import { AlertsService } from "../../../share/services/alerts";
import { CasesService } from "../../../share/services/cases";
import CaseSugester from "./components/CaseSugester";
import { IReduxState } from "src/reduxTypes";
import { connect } from 'react-redux';
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import { IAgency } from "src/share/types/agency";
import { ICreateAlertProps, ICreateAlertState, initialStateAlert, IAlertInfo } from "./types";
import { permissionsCase } from "src/share/utils/permissionsCase";
import { getAgenciesFromCase } from "src/share/utils/getAgenciesFromCase";
import AlertsInsights from "./components/Stats";
import ChildrenForm from "../ChildrenForm/ChildrenForm";
import MapForm from "src/modules/Alert/Create/components/MapForm";
import AgencyForm from "src/modules/Alert/Create/components/AgencyForm";
import AlertForm from "src/modules/Alert/Create/components/AlertForm";
import CaseInformation from "src/modules/Alert/Create/components/CaseInfo";
import { Loader } from "src/modules/Alert/Create/components/Loader";
import AlertButtons from "src/modules/Alert/Create/components/Buttons";
import { Circumstances } from "src/modules/Alert/Create/components/Circumstances";
import { AlertStatus } from "src/modules/Alert/Create/components/Status";
import { RoutesModules } from "src/modules/Routing/types";

export class CreateAlert extends React.Component<ICreateAlertProps, ICreateAlertState> {
  constructor(props: ICreateAlertProps) {
    super(props);
    this.state = _.cloneDeep(initialStateAlert);
  }
  public componentDidUpdate(prevProps: ICreateAlertProps, prevState) {
    if (this.props.match.path !== prevProps.match.path) {
      this.loadData();
    }
  }
  public componentDidMount() {
    this.loadData();
  }

  public clearData = () => {
    const initial = _.cloneDeep(initialStateAlert)
    this.setState((state) => ({
      caseInfo: this.props.match.params.caseId ? state.caseInfo : initial.caseInfo,
      alertInfo: {
        ...initial.alertInfo,
        caseId: this.props.match.params.caseId ? this.props.match.params.caseId : "",
        agencyCode: state.alertInfo.agencyCode,
        alert: ""
      }
    }))
  }
  public isEdit() {
    return this.props.match.params.alertId;
  }
  public async loadData() {
    try {
      this.setState({ loading: true });
      await Promise.all([
        this.loadAlertData(),
        this.loadCaseData()
      ]);
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false });
      toastr.error("Error", "There was a problem connecting to the server");
    }
  }
  public async loadAlertData() {
    const { alertId } = this.props.match.params;
    if (alertId) {
      const alertInfo = await AlertsService.getAlertByID(alertId) as IAlertInfo;
      if (alertInfo) {
        this.setState({ alertInfo, alertDB: _.cloneDeep(alertInfo), stopAlert: alertInfo.stop === "Yes" ? true : false });
      }
    }
  }
  public async loadCaseData() {
    try {
      const { caseId } = this.props.match.params;
      if (caseId) {
        const caseInfo = await CasesService.getCaseByID(caseId);
        if (caseInfo) {
          this.setState({
            caseInfo: { ...caseInfo, caseId }, alertInfo: {
              ...this.state.alertInfo,
              alert: this.getAgencyHeadline(caseId.split('-').shift()),
              agencyCode: this.isAdmin() ? caseInfo.agencyCode : this.props.auth.agencyCode
            }
          });
        }
      } else {
        this.clearData();
      }
    } catch (error) {
      if (error && error.error === "no data") {
        toastr.error("Error", "We couldn't find the case, information not available");
        return;
      }
      throw error;
    }
  }
  public disabled() {
    return this.isEditable() || !this.hasPermissions() || this.state.loading;
  }
  public isEditable() {
    return this.isEdit() && this.state.stopAlert ? this.state.stopAlert : this.state.loading
  }
  public hasPermissions() {
    const alertAgencyCode = this.state.alertInfo.agencyCode
    const agencyCodeToken = this.props.auth.agencyCode;
    if (this.isEdit()) {
      return agencyCodeToken === "ALL" || agencyCodeToken === alertAgencyCode
    }
    return permissionsCase(alertAgencyCode, agencyCodeToken, getAgenciesFromCase(this.state.caseInfo))
  }
  public form = (key: string, required?: boolean) => {
    return {
      name: key,
      required: required !== undefined ? required : true,
      value: _.get(this.state, `alertInfo.${key}`),
      disabled: this.disabled(),
      onChange: event => this.onInputChange(key, event),
      onSelect: event => this.onInputChange(key, event)
    };
  };
  public onInputChange = (key, event) => {
    if (event && event.currentTarget) {
      const value = key === "phone" ?
        event.currentTarget.value.replace(/\+ /g, "+").replace(/\+/g, "+ ")
        : event.currentTarget.value
      this.setValue(key, value);
    } else {
      this.setValue(key, event);
    }
  }
  public setValue = (path: string, value: any) => {
    return new Promise(resolve => {
      this.setState((state) => {
        _.set(state, `alertInfo.${path}`, value);
        return state
      }, () => resolve());
    });
  };
  public save = async () => {
    try {
      this.setState({ loading: true });
      const alert = _.cloneDeep(this.state.alertInfo);
      alert.countryName = (this.getAgency(this.state.caseInfo.agencyCode) as IAgency).country;
      delete alert.caseInfo;
      if (this.isEdit()) {
        await AlertsService.update(this.state.alertDB, alert);
        toastr.success("Add Alert", "The alert has been updated correctly");
      } else {
        const agency = this.getAgency(this.state.caseInfo.agencyCode)
        alert.language = agency && agency.language ? agency.language : 'en';
        await AlertsService.save(alert, this.state.caseInfo.caseId);
        toastr.success("Add Alert", "The alert has been saved correctly");
      }
      this.logGA();
      if (this.props.history) {
        this.props.history.replace(`/case/alerts/${this.state.caseInfo.caseId}`)
      }
      this.setState({ loading: false });
    } catch (error) {
      if (error && error.status === 404) {
        toastr.error("Error", "The selected case id doesn't exist");
      } else {
        toastr.error("Error", error.payload);
      }
      this.setState({ loading: false });
    }
  };
  public logGA() {
    ReactGA.event({
      category: 'Alert',
      action: `${this.isEdit() ? 'Updated' : 'Add new'} alert`,
      label: 'Alerts management'
    });
  }
  public getAgencyHeadline = (agencyCode) => {
    const agency = this.getAgency(agencyCode);
    return agency && agency.headline ? agency.headline : 'Missing';
  }
  public validSubmit = () => {
    if (!this.state.alertInfo.center) {
      this.setValue("location", "");
      toastr.error(
        "Location is required",
        "Please search and select the target location"
      );
      return;
    }
    if (!this.state.caseInfo.caseId) {
      toastr.error(
        "The Case Id is required",
        "Please search and select the Case Id"
      );
      return;
    }
    if (!this.areChildrenValid()) {
      toastr.error(
        "Child Information",
        "To create an alert must be selected at least one child and a photo"
      );
      return;
    }
    this.save();
  };

  public invalidSubmit = () => {
    toastr.error(
      "There are some required values",
      "Please fill all the required values"
    );
  };
  public getAgency = (agencyCode: string) => {
    return this.props.auth.agencies ? this.props.auth.agencies.find(agency => agency.code === agencyCode) : null;
  }
  public setSelected = (selected) => {
    const agency = this.getAgency(selected.agencyCode);
    this.setState(state => ({
      caseInfo: selected, alertInfo: {
        ...state.alertInfo,
        alert: agency && agency.headline ? agency.headline : 'Missing Child',
        agencyCode: this.isAdmin() ? selected.agencyCode : this.props.auth.agencyCode,
        location: agency && agency.code === state.caseInfo.agencyCode ? state.alertInfo.location : '',
        center: agency && agency.code === state.caseInfo.agencyCode ? state.alertInfo.center : undefined
      }
    }));
  }

  public isAdmin() {
    const agencyToken = this.props.auth.agencyCode;
    return agencyToken === "ALL"
  }
  public onSelectSearchBar = (change: IOnSelectChange) => {
    this.setState(state => ({
      alertInfo: {
        ...state.alertInfo,
        ...change as any
      }
    }))
  }
  public onChangeCaseId = (caseId: string) => {
    this.setState(state => ({ caseInfo: { ...state.caseInfo, caseId } }))
  }
  public areChildrenValid() {
    const { childrenSelector = {} } = this.state.alertInfo;
    return Object.keys(childrenSelector).reduce((isValid, childId) => {
      const { currentImage = "", selected = false } = childrenSelector[childId]
      return currentImage && selected ? true : isValid
    }, false);
  }
  public render() {
    const { caseId: paramsCaseId } = this.props.match.params
    const isEdit = !!this.isEdit()
    const isDisabled = this.disabled()
    const isAdmin = this.isAdmin()
    return (
      <div className="createAlert margin-forms">
        <Form
          onValidSubmit={this.validSubmit}
          onInvalidSubmit={this.invalidSubmit}
        >
          <div className="content white-background">
            <Row>
              <Col className="map-col" md={6}>
                {!isEdit && <h1>Add new alert</h1>}
                <MapForm
                  alertInfo={this.state.alertInfo}
                  auth={this.props.auth}
                  form={this.form}
                  onSelectSearchBar={this.onSelectSearchBar}
                  setValue={this.setValue}
                />
              </Col>
              <Col className="infoContainer" md={6} style={{ paddingTop: isEdit ? '40px' : '85px' }}>
                <Row className={"caseIdContainer"}>
                  <h5>Case ID:</h5>
                </Row>
                <CaseSugester
                  onChange={this.onChangeCaseId}
                  caseId={this.state.caseInfo.caseId || this.state.alertInfo.caseId || ""}
                  isEdit={isEdit || !!paramsCaseId}
                  auth={this.props.auth}
                  onSelect={this.setSelected} />
                <AgencyForm
                  auth={this.props.auth}
                  caseInfo={this.state.caseInfo}
                  form={this.form}
                  isEdit={isEdit}
                  setValue={this.setValue}
                  isAdmin={isAdmin}
                />
                <CaseInformation caseInfo={this.state.caseInfo} />
                <AlertForm
                  alertInfo={this.state.alertInfo}
                  disabled={isDisabled}
                  form={this.form}
                  onInputChange={this.onInputChange}
                  isEdit={isEdit}
                />
                <Circumstances caseInfo={this.state.caseInfo} />
                <ChildrenForm
                  disabled={isDisabled}
                  alertInfo={this.state.alertInfo}
                  caseInfo={this.state.caseInfo}
                  setValue={this.setValue}
                  isEdit={isEdit}
                />
                <AlertStatus alertInfo={this.state.alertInfo} />
                <AlertsInsights
                  isEdit={isEdit}
                  alertId={this.props.match.params.alertId}
                  caseId={this.props.match.params.caseId}
                  data={this.state.alertInfo.insights}
                />
                <Loader loading={this.state.loading} />
              </Col>
            </Row>
            <AlertButtons
              clearData={this.clearData}
              disabled={isDisabled}
              isEdit={isEdit}
            />
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.ALERTS)(connect(mapStateToProps)(CreateAlert));



// WEBPACK FOOTER //
// ./src/modules/Alert/Create/CreateAlert.tsx